import dlv from 'dlv';

// Setup auto page refresh on timer
let pageTimer = null;
export function enablePageRefresh({ pageRefreshMinutes }) {
	if (!pageRefreshMinutes || pageTimer) return;

	//Validate pageRefreshMinutes is number greater than 0
	let nPageRefreshMinutes = Number(pageRefreshMinutes);
	if (Number.isNaN(nPageRefreshMinutes) || nPageRefreshMinutes < 1) return;

	pageTimer = window.setTimeout(refreshPage, nPageRefreshMinutes * 60 * 1000);
}

function refreshPage() {
	let href = window.location.href,
		search = window.location.search;

	// Place the increment in the url
	if (!/inc=([0-9]+)/.test(search)) {
		if (search.length > 0) {
			href += '&inc=0';
		}
		else {
			href += '?inc=0';
		}
	}

	// Increment the value
	href = href.replace(/inc=([0-9]+)/, (match, inc) => {
		inc = Number(inc) + 1;
		return 'inc=' + inc;
	});

	// Reload the page
	window.location.replace(href);
}


// Common configs that are used by all components
export const COMMON_CONFIGS = {
	streamClient: 'streamClient',
	startContentServiceOrigin: 'startContentServiceOrigin',
	portalStaticOrigin: 'portalStaticOrigin',
	weatherServiceOrigin: 'weatherServiceOrigin',
	locationServiceOrigin: 'locationServiceOrigin',
	taboolaConfig: 'taboolaConfig'
};

export function getCommonProps(props) {
	if (!props) return {};
	return {
		streamClient: props.streamClient,
		startContentServiceOrigin: props.startContentServiceOrigin,
		portalStaticOrigin: props.portalStaticOrigin,
		weatherServiceOrigin: props.weatherServiceOrigin,
		locationServiceOrigin: props.locationServiceOrigin,
		taboolaConfig: props.taboolaConfig
	};
}


// Sets the class of the html body based on page theme
export function setTheme(pageConfig) {
	if (!dlv(pageConfig, 'theme')) return;

	if (pageConfig.theme === 'dark') document.body.classList.add('theme-dark');
}


export function injectCss(files) {
	if (files) {
		let head = document.head || document.getElementsByTagName('head')[0];
		files.forEach((file) => {
			let link = document.createElement('link');
			link.type = 'text/css';
			link.rel = 'stylesheet';
			link.href = file;

			head.appendChild(link);
		});
	}
}
